import React from "react";
import PropTypes from "prop-types";
import blog from "../../assets/img/blog.svg";
import blogIcone from "../../assets/icon/blogIcon.svg";
import useWindowDimensions from "../../../../hook/useWindowDimension";
import Banniere from "../../../Banniere/Banniere";

const LeBlog = ({
                    handleOpenNavItem,
                    navItem,
                    dataUser,
                    postsList
                }) => {
    const {width} = useWindowDimensions();

    return (
        navItem === "pepiteInfos-blog"
            ? <>
                <div className={"pepiteInfos-header pepiteInfos-blog-header"}>
                    {width > 1024 && <Banniere dataUser={dataUser} navItem={navItem}/>}
                    <img src={blog}/>
                    <h2 className={"titleMobile1"}>
                        Le<span className={"titleMobile3 nauticus"}> blog</span>
                    </h2>
                </div>
                <div className={"mobile-list-container blog-accueil blog-page list-cases"}>
                    <ul className={"mobile-list-container-ul"}>
                        {postsList.map((article, index) => (
                            index === 0
                                ? <div
                                    key={index}
                                    className={
                                        // "mobile-list-container " +
                                        "firstArticle"}
                                >
                                    <li key={index} className={"mobile-list-container-ul-li"}>
                                        <h2 className={"titleMobile1"}>
                                            À la<br/>
                                            <span className={"titleMobile2 nauticus"}>Une</span>
                                        </h2>
                                    </li>

                                    <ul className={"horizontal-scroll mobile-list-container-ul blog-page"}>
                                        {postsList.map((article, index) => {
                                            if (index < 1)
                                                return (
                                                    <li key={index} className={"mobile-list-container-ul-li"}
                                                        onClick={() => window.open(`https://www.prevandcare.com/leblog-caremanagement-lire-article.php?id=${article.id}`)}
                                                    >
                                                        <div className={"img"}>
                                                            <img
                                                                className={"list-elements-main-img"}
                                                                src={`https://adherents.prevandcare.com/uploads/blog/${article.id}.jpg`}/>
                                                        </div>
                                                        <div className={"article"}>
                                                            <h1>{article.titre}</h1>
                                                            <p>{article.contenu}</p>
                                                            <button
                                                            >Lire la suite
                                                            </button>
                                                        </div>
                                                    </li>
                                                );
                                        })}
                                    </ul>
                                </div>
                                :
                                <li onClick={() => window.open(`https://www.prevandcare.com/leblog-caremanagement-lire-article.php?id=${article.id}`)}
                                    key={index} className={"mobile-list-container-ul-li"}>
                                    <div><img
                                        className={"list-elements-main-img"}
                                        src={`https://adherents.prevandcare.com/uploads/blog/${article.id}.jpg`}/>
                                    </div>

                                    <div>
                                        <h1>{article.titre}</h1>
                                        <p>{article.contenu}</p>
                                        <button
                                        >Lire la suite
                                        </button>
                                    </div>
                                </li>
                        ))}
                    </ul>
                </div>
            </>
            : <>
                <li className={"mobile-list-container-ul-li"}>
                    <h3><img src={blogIcone}/>Le blog</h3>
                    <h2 className={"titleMobile1"}>
                        À la<br/>
                        <span className={"titleMobile2 nauticus"}>Une</span>
                    </h2>
                    <p onClick={() => {
                        const title = "pepiteInfos-blog";
                        handleOpenNavItem(title);
                    }} className={"voirTout"}>Voir tout</p>

                </li>
                <ul id={"blog-accueil-ul"} className={"horizontal-scroll mobile-list-container-ul blog-page"}>
                    {postsList.map((article, index) => {
                        if ((width > 599 && index < 3) || (width < 599 && index < 3))
                            return (
                                <li onClick={() => window.open(`https://www.prevandcare.com/leblog-caremanagement-lire-article.php?id=${article.id}`)}
                                    key={index}
                                    className={"mobile-list-container-ul-li"}
                                >
                                    <div className={"img"}>
                                        <img
                                            className={"list-elements-main-img"}
                                            src={`https://adherents.prevandcare.com/uploads/blog/${article.id}.jpg`}/>
                                    </div>
                                    <div className={"article"}>
                                        <h1>{article.titre}</h1>
                                        <p>{article.contenu}</p>
                                        <button
                                        >Lire la suite
                                        </button>
                                    </div>
                                </li>
                            );
                    })}
                </ul>
            </>
    );
};

LeBlog.propTypes = {
    handleOpenNavItem: PropTypes.func,
    navItem: PropTypes.string,
    dataUser: PropTypes.object,
    postsList: PropTypes.array
};

export default LeBlog;